import { Rule, HTMLarkdownOptions, PassDownOptions, FilterPredicate } from 'htmlarkdown';

export const horizontalRuleFilter: FilterPredicate = (element: Element): boolean => {
  return element.tagName.toLowerCase() === 'hr';
};

export const horizontalRule: Rule = {
  filter: [horizontalRuleFilter],
  replacement: (_element: Element, _options: HTMLarkdownOptions, _parentOptions: PassDownOptions): string => {
    return '';
  }
};
